<template>
    <div>
        <div class="wrap_div">
            <!-- <div v-for="(item,index) in list" :key="index" class="recharge_list" :style="{'background-image':'url('+item.imageUrl+')'}">
                <div class="recharge_title">{{item.name}}</div>
                <div class="recharge_text">{{item.dec}}</div>
                <button 
                class="buy_btn" 
                :class="[index%2 == 0 ? 'yellow' : 'red']"
                @click="buyFun($event)"
                :data-id="item.id"
                >立即购买</button>
            </div>
            <div class="recharge_list" :style="{'background-image':`url(${require('../assets/8.png')})`}">
                <div class="rechar_flex">
                    <div class="recharge_title">其他</div>
                    <input type="text" placeholder="不能低于10元" class="other_input">
                </div>
                <button 
                class="buy_btn yellow"
                >立即购买</button>
            </div> -->
            <div 
                class="item_div" 
                :class="{'action':select_index == index}" 
                v-for="(item,index) in array" 
                :key="index" 
                @click="itemSelectFun(index,$event)"
                :data-money="item.money"
                :data-name="item.name"
            >
                <span>{{item.money}}元</span>
            </div>
            <div class="other_item_div">
                <span>其他</span>
                <input type="text" placeholder="不能低于10元" class="other_input_val" @input="otherInputFun" v-model="other_input_val">
            </div>
        </div>
        <button class="buy_button" @click="buyOtherFun">购买</button>
		<div class="shop_info" style="text-align: center; margin-top: 10px;">
		<div style="padding: 5px 0;">电表编号：{{snCode}}</div>
		<div style="padding: 5px 0;">店铺地址：{{storeName}}</div>
		</div>
    </div>
</template>

<script>
import autho from '../autho/autho.js'
import wxSDK from '../utils/wx-sdk.js'
import Vue from 'vue';
import { Toast } from 'vant';
Vue.use(Toast);
var that;
export default {
    data(){
        return {
            list:[],
            accountCode:null,
			snCode:'',
			storeName:'',
            array:[
                {
                    money:300,
                    name:'300元'
                },
                {
                    money:500,
                    name:'500元'
                },
                {
                    money:1000,
                    name:'1000元'
                },
                {
                    money:3000,
                    name:'3000元'
                }
            ],
            other_input_val:'',
            select_index:null,
            getMoney:0,
            getName:'',
        }
    },
    beforeCreate(){
        document.querySelector('body').style.background = '#f6f6f6'
    },
  watch: {
    '$route'(to, from) {
      // 路由参数变化时执行
      if (to.query.accountCode !== from.query.accountCode) {
        this.loadUserData(to.query.accountCode,to.query.snCode,to.query.storeName);
      }
    }
  },
    mounted(){
        that = this;
        that.accountCode = that.$route.query.accountCode;
		that.snCode = that.$route.query.snCode;
		that.storeName = that.$route.query.storeName;
         const url = window.location.href;
         wxSDK.getJsTicket(url)
        // that.buyFun()
    },
    methods:{
        async buyFun(){
            // window.location.href = 'http://hxwuye.hao-yong.cn/gzh-intelligent-power/gzhWxApiController/recharge'
            const res = await autho.request('token','post','/gzhWxApiController/rechargeByWx',{
                    accountCode:that.accountCode,
                    money:that.getMoney*100,
                    name:that.getName
                })
            autho.resetDataFun(res,function(){
                let _data = res.data.data;
                wxSDK.payFun(_data)
 
            })
            //document.write(res.data)
        },
		loadUserData(accountCode,snCode,storeName) {
			// 加载新数据
			that = this;
			that.accountCode = accountCode;
			that.snCode = snCode;
			that.storeName = storeName;
		},
        // input输入值
        otherInputFun(e){
            let e_val = e.target.value;
            that.other_input_val = that.getMoney = e_val;
            that.select_index = null;
            that.getName = e_val ? `${e_val}元` : '';
        },
        // 点击购买，判断input输入值是否合法
        async buyOtherFun(){
            let reg = /^(\d*)+(\.\d{1,2})$|^[1-9]\d*$/;
            if(!that.getMoney){
                Toast({message:'请选择充值金额',forbidClick:true});
                return false;
            }
            if(!reg.test(that.getMoney)){
                Toast({message:'请输入正数或小数点两位正数',forbidClick:true});
                return false;
            }
            // if(parseFloat(that.getMoney) < 10){
            //     Toast({message:'请输入不低于10的整数',forbidClick:true});
            //     return false;
            // }
            that.buyFun()
        },
        // 价位选择
        itemSelectFun(index,e){
            that.select_index = index;
            that.other_input_val = '';
            that.getMoney = e.currentTarget.dataset.money;
            that.getName = e.currentTarget.dataset.name;
        }
    }
}
</script>

<style scoped>
.recharge_list {
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    width: 3.45rem;
    height: 1.4rem;
    margin: 0.18rem auto 0;
    box-shadow: 0px 2px 5px 2px rgb(140 140 144 / 50%);
    border-radius: 0.15rem;
    overflow: hidden;
    padding-left: 0.28rem;
    box-sizing: border-box;
}
.recharge_title {
    font-size: 0.24rem;
    margin-top: 0.25rem;
    color: #fff;
}
.recharge_text {
    font-size: 0.14rem;
    color: #fff;
    margin-top: 0.05rem;
}
.buy_btn {
    width: 0.97rem;
    height: 0.3rem;
    border-radius: 0.3rem;
    border: none;
    outline: none;
    color: #fff;
    font-size: 0.14rem;
    margin-top: 0.1rem;
}
.yellow {
    background: #ffc272;
}
.red {
    background: #ff7c72;
}
.rechar_flex {
    display: flex;
    align-items: flex-end;
    margin-bottom: 0.2rem;
}
.other_input {
    outline: none;
    border-radius: 0.05rem;
    border:1px solid #ccc;
    padding: 0 0.1rem;
    font-size: 0.14rem;
    margin-left: 0.1rem;
    width: 1rem;
    height: 0.25rem;
    background: rgb(255 255 255/20%);
    color: #fff;
}


.wrap_div {
    display: flex;
    flex-wrap: wrap;
    padding: 0 0.2rem;
}
.item_div {
    border: 1px solid green;
    width: 1rem;
    height: 0.5rem;
    text-align: center;
    line-height: 0.5rem;
    box-sizing: border-box;
    margin: 0.2rem 0.15rem 0 0;
    background: rgb(0 0 0/0%);
}
.item_div:nth-child(3n){
    margin: 0.2rem 0 0 0;
}
.item_div.action {
    background: green;
}
.item_div.action span {
    color: #fff;
}
.item_div span {
    font-size: 0.16rem;
    color: green;
}
.other_item_div {
    border: 1px solid green;
    width: 2.15rem;
    height: 0.5rem;
    box-sizing: border-box;
    margin-top: 0.2rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
}
.other_item_div span {
    font-size: 0.16rem;
    color: green;
}
.other_input_val {
    border: 1px solid green;
    width: 1.4rem;
    height: 0.25rem;
    font-size: 0.14rem;
    color: green;
    outline: none;
    padding: 0 0.05rem;
    box-sizing: border-box;
    background: rgb(0 0 0/0%);
}
.buy_button {
    width: 80%;
    height: 0.4rem;
    border:none;
    outline: none;
    background: green;
    color: #fff;
    font-size: 0.16rem;
    margin: 0.2rem auto 0;
    display: block;
    border-radius: 0.1rem;
}
</style>